import { render, staticRenderFns } from "./procUser.vue?vue&type=template&id=277d32e1&scoped=true"
import script from "./procUser.vue?vue&type=script&lang=js"
export * from "./procUser.vue?vue&type=script&lang=js"
import style0 from "./procUser.vue?vue&type=style&index=0&id=277d32e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277d32e1",
  null
  
)

export default component.exports